'use client'

import { Suspense } from 'react'
import { useAffiliateTracking } from '@/hooks/useAffiliateTracking'

// Component that handles the tracking logic
function AffiliateTrackerInner() {
  // This hook will automatically track any partner parameter in the URL
  useAffiliateTracking()
  return null // This component renders nothing
}

// Wrapper with Suspense for useSearchParams
export function AffiliateTracker() {
  return (
    <Suspense fallback={null}>
      <AffiliateTrackerInner />
    </Suspense>
  )
}
